import { createAction } from '@reduxjs/toolkit';
import { MANAGE_VIEW_ACTIONS } from './viewActionConstants';
import { IUserContext } from '../../interfaces/ManageView';

export const setUserProfile = createAction(
  MANAGE_VIEW_ACTIONS.UPDATE_USER_PROFILE,
  function prepare(userProfile: IUserContext) {
    return {
      payload: userProfile,
    };
  }
);
